
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/[slug]/earnings/[quarter]",
      function () {
        return require("private-next-pages/company/[slug]/earnings/[quarter]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/[slug]/earnings/[quarter]"])
      });
    }
  